import React, { useEffect } from "react"
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
  Table,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { getOrderDetails, syncOrderWithPos } from "store/actions/orderAction"
import { useSelector } from "react-redux"
import { ShimmerSimpleGallery } from "react-shimmer-effects"
import TableShimmer from "components/Shared/TableShimmer"
import BackButton from "components/Shared/BackButton"
import StarRatings from "react-star-ratings"
import { statusListStatus } from "components/Common/constants"
import formatDateTime from "components/Shared/formatDateTime"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import { showAlert } from "store/reducers/alertReducer"
import { DOMAIN_URL } from "helpers/api_helper"

const ViewOrder = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Order Details | Namq")

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      9,
      "order_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  const { loading, isLoading, orderDetails } = useSelector(
    state => state.Orders
  )

  const fetchOrderDetails = () => {
    dispatch(getOrderDetails(id))
  }

  useEffect(() => {
    fetchOrderDetails()
  }, [])

  function formatDate(dateString) {
    const date = new Date(dateString)
    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")} ${date
      .getHours()
      .toString()
      .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}:${date
      .getSeconds()
      .toString()
      .padStart(2, "0")}`
    return formattedDate
  }

  const formatPromiseDateTime = dateTimeString => {
    if (!dateTimeString) return "-"
    const date = new Date(dateTimeString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    let hours = date.getHours()
    const meridiem = hours >= 12 ? "PM" : "AM"
    hours = hours % 12 || 12 // Convert 0 to 12 for 12-hour clock
    const minutes = String(date.getMinutes()).padStart(2, "0")
    const seconds = String(date.getSeconds()).padStart(2, "0")

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${meridiem}`
  }

  const copyToClipboard = data => {
    const dataString = JSON.stringify(data, null, 2)

    const textarea = document.createElement("textarea")
    textarea.value = dataString
    textarea.setAttribute("readonly", "")
    textarea.style.position = "absolute"
    textarea.style.left = "-9999px"
    document.body.appendChild(textarea)

    try {
      textarea.select()
      const successful = document.execCommand("copy")
      if (successful) {
        dispatch(
          showAlert({ text: t("Data copied to clipboard!"), type: "success" })
        )
      } else {
        dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }))
      }
    } catch (err) {
      dispatch(showAlert({ text: t("Failed to copy"), type: "failed" }))
    } finally {
      document.body.removeChild(textarea)
    }
  }

  const handleSentOnPOS = () => {
    const payload = {
      orderId: orderDetails?._id,
    }
    dispatch(syncOrderWithPos(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          fetchOrderDetails()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs />
          {loading ? (
            <ShimmerSimpleGallery card imageHeight={500} col={3} row={1} />
          ) : (
            <Row>
              <Col xl="4">
                <Card className="card_100_24">
                  <CardBody>
                    <CardTitle className="mb-4 d-flex align-items-center">
                      <BackButton />
                      {t("Order Details")}
                    </CardTitle>
                    <div className="table-responsive capitalize_td">
                      {/* {userDetails && Object.values(userDetails).length === 0 ? (
                      <p className="text-center">No order found</p>
                    ) : ( */}
                      <Table className="mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Order No")}</th>
                            <td>{orderDetails.invoiceNo || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Order Type")}</th>
                            <td>{t(orderDetails.orderType) || "-"}</td>
                          </tr>
                          {/* <tr>
                          <th scope="row">Coupon</th>
                          <td>{orderDetails.coupon || "-"}</td>
                        </tr> */}

                          <tr>
                            <th scope="row">{t("Country")}</th>
                            <td>
                              {language === "sa"
                                ? orderDetails?.countryId?.nameAr
                                : orderDetails?.countryId?.name || "-"}
                            </td>
                          </tr>
                          {/* <tr>
                            <th scope="row">Invoice Url</th>
                            <td>{orderDetails.invoiceUrl || "-"}</td>
                          </tr> */}
                          <tr>
                            <th scope="row">{t("Branch Name")}</th>
                            <td>
                              {language === "sa"
                                ? orderDetails?.branchId?.nameAr
                                : orderDetails?.branchId?.name || "-"}
                            </td>
                          </tr>
                          {/* <tr>
                            <th scope="row">Payment Method</th>
                            <td>{orderDetails.paymentMethod || "-"}</td>
                          </tr> */}

                          {/* <tr>
                            <th scope="row">Schedule Type</th>
                            <td>{orderDetails.scheduleType || "-"}</td>
                          </tr> */}
                          <tr>
                            <th scope="row">{t("Promise Date")}</th>
                            <td>
                              {formatPromiseDateTime(
                                orderDetails.promiseDateTime
                              )?.split(" ")[0] || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Promise Time")}</th>
                            <td>
                              {formatPromiseDateTime(
                                orderDetails.promiseDateTime
                              )?.split(" ")[1] || "-"}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Order Type")}</th>
                            <td>{orderDetails.orderType || "-"}</td>
                          </tr>
                        </tbody>
                      </Table>
                      {/* )} */}

                      <CardTitle className="mt-4 d-flex align-items-center">
                        {t("POS Details")}
                      </CardTitle>
                      <Table className="mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Organization Id")}</th>
                            <td>
                              {orderDetails?.posSettings?.organizationId || "-"}
                              {orderDetails?.posSettings?.organizationId && (
                                <i
                                  className="mdi mdi-content-copy cursor-pointer text-primary fs-4 ms-2"
                                  id="copytooltip"
                                  onClick={() =>
                                    copyToClipboard(
                                      orderDetails?.posSettings?.organizationId
                                    )
                                  }
                                ></i>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Terminal Id")}</th>
                            <td>
                              {orderDetails?.posSettings?.terminalGroupId ||
                                "-"}
                              {orderDetails?.posSettings?.terminalGroupId && (
                                <i
                                  className="mdi mdi-content-copy cursor-pointer text-primary fs-4 ms-2"
                                  id="copytooltip"
                                  onClick={() =>
                                    copyToClipboard(
                                      orderDetails?.posSettings?.terminalGroupId
                                    )
                                  }
                                ></i>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("POS Reference Order Id")} </th>
                            <td>
                              {orderDetails?.posReferenceId || "-"}
                              {orderDetails?.posReferenceId && (
                                <i
                                  className="mdi mdi-content-copy cursor-pointer text-primary fs-4 ms-2"
                                  id="copytooltip"
                                  onClick={() =>
                                    copyToClipboard(orderDetails.posReferenceId)
                                  }
                                ></i>
                              )}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("POS Status")} </th>
                            <td>
                              <div className="d-flex gap-3">
                                <p
                                  className={`${
                                    orderDetails?.posSettings?.status ===
                                    "Success"
                                      ? "text-success"
                                      : orderDetails?.posSettings?.status ===
                                        "Error"
                                      ? "text-danger"
                                      : orderDetails?.posSettings?.status ===
                                        "InProgress"
                                      ? "text-primary"
                                      : ""
                                  }`}
                                >
                                  {orderDetails?.posSettings?.status || "-"}
                                </p>
                                {orderDetails?.posSettings?.status ===
                                  "Error" && (
                                  <Button
                                    color="primary"
                                    title={t("Sync Order With POS")}
                                    onClick={handleSentOnPOS}
                                    disabled={isLoading}
                                  >
                                    {t("Send on POS")}
                                  </Button>
                                )}
                              </div>
                            </td>
                          </tr>
                          {orderDetails?.posSettings?.errorInfo && (
                            <tr>
                              <th scope="row">{t("Error Information")} </th>
                              <td>
                                <p className="text-danger">
                                  {orderDetails?.posSettings?.errorInfo || "-"}
                                </p>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl="4">
                <Card className="card_100_24">
                  <CardBody>
                    <CardTitle className="mb-4">
                      {t("Payments Details")}
                    </CardTitle>
                    <div className="table-responsive">
                      <Table className="table-nowrap mb-0">
                        <tbody>
                          <tr>
                            <th scope="row">{t("Coupon")}</th>
                            <td>{orderDetails?.coupon?.code || "-"} </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Discount Type")}</th>
                            <td>{orderDetails.discountType || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Total")}</th>
                            <td>
                              {orderDetails?.splitPayments?.total}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("VAT Amount")}</th>
                            <td>
                              {orderDetails?.splitPayments?.vatAmount}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("VAT %")}</th>
                            <td>{orderDetails?.splitPayments?.vatValue}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Online")}</th>
                            <td>
                              {orderDetails?.splitPayments?.gatewayAmount}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Discounted Amount")}</th>
                            <td>
                              {orderDetails?.splitPayments?.discountedAmount}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Wallet Amount")}</th>
                            <td>
                              {orderDetails?.splitPayments?.walletAmount}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Loyalty Amount")}</th>
                            <td>
                              {orderDetails?.splitPayments?.rewardAmount}{" "}
                              {orderDetails?.splitPayments?.currency}
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Loyalty Redeemed points")}</th>
                            <td>{orderDetails?.splitPayments?.rewardPoints}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Loyalty Earned Points")}</th>
                            <td>{orderDetails?.earnPoints}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Payment Method")}</th>
                            <td>{t(orderDetails?.paymentMethod) || "-"}</td>
                          </tr>
                          <tr>
                            <th scope="row">{t("Payment Status")}</th>
                            <td>
                              {orderDetails.paymentStatus === 1 && t("Paid")}
                              {orderDetails.paymentStatus === 2 &&
                                t("Refunded")}
                            </td>
                          </tr>
                          {orderDetails.paymentStatus === 2 && (
                            <tr>
                              <th scope="row">{t("Refund At")}</th>
                              <td>
                                {formatDate(
                                  orderDetails?.transaction?.refundInfo
                                    ?.refundAt
                                )}
                              </td>
                            </tr>
                          )}
                          <tr>
                            <th scope="row">{t("Payment Reference")}</th>
                            <td>
                              {orderDetails?.transaction?.transactionId || "-"}{" "}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                      {/* )} */}
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col xl="4">
                <Card className="card_100_24">
                  <CardBody>
                    <CardTitle className="mb-4 d-flex align-items-center">
                      {t("Customer Details")}
                    </CardTitle>
                    <div className="table-responsive">
                      {orderDetails &&
                      Object.values(orderDetails).length === 0 ? (
                        <p className="text-center">
                          {t("No customer details found")}
                        </p>
                      ) : (
                        <Table className="table-nowrap mb-0">
                          <tbody>
                            <tr>
                              <th scope="row">{t("Name")}</th>
                              <td className="text-capitalize">
                                <Link
                                  to={`/customers/customer-details?id=${orderDetails?.userId?._id}`}
                                  className="text-underline"
                                >
                                  {`${orderDetails?.userId?.firstName} ${orderDetails?.userId?.lastName}` ||
                                    "-"}
                                </Link>
                              </td>
                            </tr>
                            {/* <tr>
                              <th scope="row">First Name</th>
                              <td className="text-capitalize">
                                {orderDetails?.userId?.firstName || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Last Name</th>
                              <td className="text-capitalize">
                                {orderDetails?.userId?.lastName || "-"}
                              </td>
                            </tr> */}
                            <tr>
                              <th scope="row">{t("Email")}</th>
                              <td>{orderDetails?.userId?.email || "-"}</td>
                            </tr>
                            <tr>
                              <th scope="row">{t("Phone Code")}</th>
                              <td>{orderDetails?.userId?.phoneCode || "-"}</td>
                            </tr>
                            <tr>
                              <th scope="row">{t("Phone Number")}</th>
                              <td>
                                {orderDetails?.userId?.phoneNumber || "-"}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">{t("Platform")}</th>
                              <td>{t(orderDetails?.platform) || "-"}</td>
                            </tr>
                            {/* <tr>
                              <th scope="row">Is Rated</th>
                              <td>
                                {orderDetails?.isUserRated
                                  ? "Yes"
                                  : "No" || "-"}
                              </td>
                            </tr> */}
                          </tbody>
                        </Table>
                      )}
                    </div>
                    {orderDetails?.orderType === "curbside" && (
                      <>
                        <CardTitle className=" mt-4 d-flex align-items-center">
                          {t("Vehicle Details")}
                        </CardTitle>
                        <div className="table-responsive">
                          <Table className="table-nowrap mb-0">
                            <tbody>
                              <tr>
                                <th scope="row">{t("Name")}</th>
                                <td>
                                  <div className="d-flex gap-1 align-items-center">
                                    {orderDetails?.userVehicleId?.vehicleId
                                      ?.logo && (
                                      <img
                                        src={
                                          orderDetails?.userVehicleId?.vehicleId
                                            ?.logo
                                        }
                                        width={20}
                                        height={20}
                                      />
                                    )}
                                    {orderDetails?.userVehicleId?.vehicleId
                                      ?.brand || "-"}
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">{t("Color")}</th>
                                <td>
                                  <div className="d-flex align-items-center gap-1">
                                    <p
                                      className="mb-0"
                                      style={{
                                        background:
                                          orderDetails?.userVehicleId?.colorId
                                            ?.code,
                                        width: 18,
                                        height: 18,
                                        borderRadius: "50%",
                                      }}
                                    ></p>
                                    <p className="mt-0 mb-0">
                                      {orderDetails?.userVehicleId?.colorId
                                        ?.name || "-"}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                              <tr>
                                <th scope="row">{t("Plate Number")}</th>
                                <td>
                                  {orderDetails?.userVehicleId?.plateNumber ||
                                    "-"}
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {loading ? (
            <ShimmerSimpleGallery card imageHeight={500} col={1} row={1} />
          ) : (
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle>{t("Order Items")}</CardTitle>
                    <div className="table-responsive">
                      {orderDetails?.orderItems?.length === 0 ? (
                        <p className="text-center my-3">
                          {t("No orders items found")}
                        </p>
                      ) : (
                        <Table className="table mb-0" hover>
                          <thead className="table-light">
                            <tr>
                              <th>{t("Item")}</th>
                              <th>{t("Name(English)")}</th>
                              <th>{t("Name(عربي)")}</th>
                              <th>{t("Price")}</th>
                              {/* <th>Modifier Price</th> */}
                              <th>{t("Quantity")}</th>
                              <th>{t("Total Price")}</th>
                              {/* <th>Modifier Groups</th>
                              <th>Modifiers</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {orderDetails?.orderItems?.map(item => (
                              <tr key={item?._id}>
                                <td>
                                  {item?.itemId?.imageUrl ? (
                                    <img
                                      style={{
                                        maxWidth: 50,
                                        maxHeight: 50,
                                        objectFit: "contain",
                                      }}
                                      src={item?.itemId?.imageUrl}
                                      alt=""
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <p className="fw-bold mb-2">
                                    {item?.itemId?.name || "-"}{" "}
                                  </p>
                                  {/* SHOW MODIFIERS */}
                                  {item?.modifiers?.map(subItem => (
                                    <React.Fragment key={subItem._id}>
                                      {subItem?.selectedModifiers?.map(
                                        (item2, index) => (
                                          <>
                                            <span key={index}>
                                              {item2?.modifier?.name}
                                            </span>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </React.Fragment>
                                  ))}
                                </td>
                                <td>
                                  <p className="fw-bold mb-2">
                                    {item?.itemId?.nameAr || "-"}
                                  </p>
                                  {item?.modifiers?.map(subItem => (
                                    <React.Fragment key={subItem._id}>
                                      {subItem?.selectedModifiers?.map(
                                        (item2, index) => (
                                          <>
                                            <span key={index}>
                                              {item2?.modifier?.nameAr}
                                            </span>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </React.Fragment>
                                  ))}
                                </td>
                                <td>
                                  <p className="fw-bold mb-2">
                                    {item.price}{" "}
                                    {orderDetails?.splitPayments?.currency}
                                  </p>
                                  {item?.modifiers?.map(subItem => (
                                    <React.Fragment key={subItem._id}>
                                      {subItem?.selectedModifiers?.map(
                                        (item2, index) => (
                                          <>
                                            <span key={index}>
                                              {item2?.price}{" "}
                                              {
                                                orderDetails?.splitPayments
                                                  ?.currency
                                              }
                                            </span>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </React.Fragment>
                                  ))}
                                </td>
                                {/* <td>{item.mofifierPrice} SAR</td> */}
                                <td>
                                  <p className="fw-bold mb-2">
                                    {item.quantity}
                                  </p>
                                  {item?.modifiers?.map(subItem => (
                                    <React.Fragment key={subItem._id}>
                                      {subItem?.selectedModifiers?.map(
                                        (item2, index) => (
                                          <>
                                            <span key={index}>
                                              {item2?.quantity}
                                            </span>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </React.Fragment>
                                  ))}
                                </td>
                                <td className="fw-bold">
                                  {item.totalPrice}{" "}
                                  {orderDetails?.splitPayments?.currency}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
          {loading ? null : (
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <CardTitle>{t("Order History")}</CardTitle>
                    <div className="table-responsive">
                      {orderDetails?.statusHistory?.length === 0 ? (
                        <p className="text-center my-3">
                          {t("No orders history found")}
                        </p>
                      ) : (
                        <Table className="table mb-0" hover>
                          <thead className="table-light">
                            <tr>
                              <th>{t("Title")}</th>
                              <th>{t("Status")}</th>
                              <th>{t("Date")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {orderDetails?.statusHistory?.map(item => (
                              <tr key={item._id}>
                                <td>
                                  {language === "sa"
                                    ? item?.title?.ar
                                    : item?.title?.en}
                                </td>
                                <td>{statusListStatus[item.status].text}</td>
                                <td> {formatDateTime(item?.date)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* {loading ? null : (
            <Row>
              <Col>
                <Card>
                  <CardBody className="overflow-auto">
                    <CardTitle>Order Ratings & Feedbacks</CardTitle>
                    <div
                      className="table-responsive"
                      style={{ maxHeight: 600 }}
                    >
                      {orderLoading ? (
                        <TableShimmer row={5} col={5} />
                      ) : orders.length === 0 ? (
                        <p className="text-center my-2">No orders found</p>
                      ) : (
                      <Table className="table mb-0">
                        <thead className="fixed_thead">
                          <tr>
                            <th>S. No.</th>
                            <th>Product Title</th>
                            <th>Rating</th>
                            <th>Feedback</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Product</td>
                            <td>
                              <StarRatings
                                rating={4}
                                starRatedColor="#F1B44C"
                                starEmptyColor="#74788d"
                                numberOfStars={5}
                                name="rating"
                                starDimension="14px"
                                starSpacing="3px"
                              />
                            </td>
                            <td>Lorem ipsum dolor sit amet.</td>
                            <td>20-05-2024</td>
                          </tr>
                        </tbody>
                      </Table>
                       )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )} */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewOrder
